import React, { useState, useEffect } from 'react';
import { API_BASE } from './lib/runtimeConfig';

const calNavBtn = { background: 'none', border: '1px solid #e2e8f0', borderRadius: 6, width: 28, height: 28, cursor: 'pointer', fontWeight: 700, fontSize: 16 };

// maxCheckin: última fecha de llegada permitida (ventana de reservas); la salida sí puede pasar de ahí
const MiniCalendar = ({ propertyId, checkin, checkout, onSelectCheckin, onSelectCheckout, maxCheckin }) => {
    const [blockedDates, setBlockedDates] = useState(new Set());
    const [monthOffset, setMonthOffset] = useState(0);

    useEffect(() => {
        if (!propertyId) return;
        // Cargar fechas bloqueadas de los próximos 12 meses
        const start = new Date(); start.setDate(1);
        const end   = new Date(); end.setMonth(end.getMonth() + 12); end.setDate(0);
        const s = start.toISOString().split('T')[0];
        const e = end.toISOString().split('T')[0];
        fetch(`${API_BASE}/api/reservations/blocked-dates?propertyId=${propertyId}&from=${s}&to=${e}`)
            .then(r => r.json())
            .then(data => setBlockedDates(new Set(Array.isArray(data?.dates) ? data.dates : [])))
            .catch(() => {});
    }, [propertyId]);

    const today = new Date(); today.setHours(0,0,0,0);
    const baseMonth = new Date(today.getFullYear(), today.getMonth() + monthOffset, 1);
    const year = baseMonth.getFullYear();
    const month = baseMonth.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();
    const monthLabel = baseMonth.toLocaleDateString('es-CO', { month: 'long', year: 'numeric' });

    const isBlocked  = d => blockedDates.has(d);
    const isPast     = d => d < today.toISOString().split('T')[0];
    const isCheckin  = d => d === checkin;
    const isCheckout = d => d === checkout;
    const isInRange  = d => checkin && checkout && d > checkin && d < checkout;
    const eligeSalida   = checkin && !checkout;
    const fueraVentana  = d => !!maxCheckin && d > maxCheckin;
    const noSeleccionable = d => isBlocked(d) || isPast(d) || (fueraVentana(d) && !(eligeSalida && d > checkin));

    const handleDay = (dateStr) => {
        if (noSeleccionable(dateStr)) return;
        if (!checkin || (checkin && checkout)) { onSelectCheckin(dateStr); onSelectCheckout(''); }
        else if (dateStr <= checkin) { onSelectCheckin(dateStr); onSelectCheckout(''); }
        else { onSelectCheckout(dateStr); }
    };

    const days = [];
    for (let i = 0; i < (firstDay === 0 ? 6 : firstDay - 1); i++) days.push(null);
    for (let d = 1; d <= daysInMonth; d++) {
        const dateStr = `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
        days.push(dateStr);
    }

    return (
        <div style={{ userSelect: 'none' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <button onClick={() => setMonthOffset(o => Math.max(0, o - 1))} style={calNavBtn}>‹</button>
                <span style={{ fontWeight: 700, fontSize: 13, textTransform: 'capitalize' }}>{monthLabel}</span>
                <button onClick={() => setMonthOffset(o => o + 1)} style={calNavBtn}>›</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 2, marginBottom: 4 }}>
                {['Lu','Ma','Mi','Ju','Vi','Sa','Do'].map(d => <div key={d} style={{ textAlign:'center', fontSize:10, fontWeight:700, color:'#94a3b8', padding:'2px 0' }}>{d}</div>)}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 2 }}>
                {days.map((dateStr, idx) => {
                    if (!dateStr) return <div key={idx} />;
                    const blocked  = noSeleccionable(dateStr);
                    const ci       = isCheckin(dateStr);
                    const co       = isCheckout(dateStr);
                    const inRange  = isInRange(dateStr);
                    const day      = parseInt(dateStr.split('-')[2]);
                    return (
                        <div key={dateStr} onClick={() => handleDay(dateStr)} style={{
                            textAlign: 'center', padding: '6px 2px', borderRadius: ci || co ? '50%' : inRange ? 0 : 6,
                            background: ci || co ? '#003366' : inRange ? '#dbeafe' : 'transparent',
                            color: ci || co ? '#fff' : blocked ? '#d1d5db' : inRange ? '#1e40af' : '#0f172a',
                            cursor: blocked ? 'not-allowed' : 'pointer',
                            fontSize: 12, fontWeight: ci || co ? 800 : 400,
                            textDecoration: blocked ? 'line-through' : 'none',
                        }}>
                            {day}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MiniCalendar;
